import { EffortStats } from "../types";
import { ManualEffort } from "~/operations";

type ExtractEffortStatsParams = {
  findings: {
    manualEffort?: Partial<ManualEffort> | null;
  }[];
};

// Calculating categorized stats for time for coding, testing, releasing to remediate a list of aggregate scores or findings
export function extractEffortStats({ findings }: ExtractEffortStatsParams) {
  const initialStats = {
    research: 0,
    scripting: 0,
    verification: 0,
    rollout: 0,
    total: 0,
  };

  return (
    findings.reduce<EffortStats>((acc, curr) => {
      return {
        ...acc,
        research: acc.research + (curr?.manualEffort?.research || 0),
        scripting: acc.scripting + (curr?.manualEffort?.scripting || 0),
        verification:
          acc.verification + (curr?.manualEffort?.verification || 0),
        rollout: acc.rollout + (curr?.manualEffort?.rollout || 0),
        total: acc.total + (curr?.manualEffort?.totalManualEffort || 0),
      };
    }, initialStats) || initialStats
  );
}
